var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSavingicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5489_1291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.027 13.821L18.7764 12.8191C19.057 12.6587 19.3897 12.6159 19.7019 12.6999C20.014 12.7839 20.2802 12.988 20.4424 13.2676L20.4568 13.2924C20.6079 13.5495 20.6626 13.8519 20.6112 14.1455C20.5598 14.4392 20.4057 14.705 20.1763 14.8955L16.9232 17.5807C16.7287 17.7416 16.4985 17.8538 16.2519 17.9081L10.08 19.2796C9.86895 19.3264 9.65056 19.3301 9.43802 19.2904C9.22547 19.2506 9.02316 19.1683 8.84326 19.0483L5.00707 16.495C4.74372 16.3194 4.43428 16.2257 4.11775 16.2257H3V11.4164L5.84548 11.1002C6.34637 11.0445 6.85333 11.1078 7.32513 11.2849L9.51536 12.1061C9.71356 12.1806 9.9187 12.2351 10.1277 12.2688L14.2252 12.9337C14.5508 12.9572 14.8554 13.1031 15.0778 13.3421C15.3002 13.5811 15.4239 13.8954 15.4239 14.2218C15.4239 14.5483 15.3002 14.8627 15.0777 15.1017C14.8552 15.3406 14.5505 15.4865 14.2248 15.5099L9.81313 15.8249",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8208 10.7139C18.089 10.7139 19.9278 8.87516 19.9278 6.60696C19.9278 4.33875 18.089 2.5 15.8208 2.5C13.5526 2.5 11.7139 4.33875 11.7139 6.60696C11.7139 8.87516 13.5526 10.7139 15.8208 10.7139Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8219 5.0038L14.2188 6.60693L15.8219 8.21007L17.425 6.60693L15.8219 5.0038Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5489_1291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavingicon);
export default __webpack_public_path__ + "static/media/savingicon.1c9627d44a5877f8dcaabf95a122766a.svg";
export { ForwardRef as ReactComponent };